import React, { useState, useEffect, useRef } from "react"
import { getMediaUrl } from "../../utils/media"

function LandingSignposts({ landingSignpostsTitle, landingSignpostsItems }) {
  const popoverRef = useRef(null)

  const [activeSignpost, setActiveSignpost] = useState({
    modalHash: "",
    modalText: "",
    modalImage: null,
  })

  useEffect(() => {
    let windowHash = window.location.hash
    let hashId = windowHash.replace("#", "")

    if (hashId) {
      let hashedSignpost = landingSignpostsItems.filter(
        item => item.landingSignpostModalId === hashId
      )[0]

      if (hashedSignpost) {
        setActiveSignpost({
          modalHash: hashId,
          modalText: hashedSignpost.landingSignpostModalText,
          modalImage: hashedSignpost.landingSignpostModalImage,
        })
        popoverRef.current.showPopover()
      }
    } else if (
      Boolean(landingSignpostsItems && landingSignpostsItems.length > 0)
    ) {
      setActiveSignpost({
        modalHash: landingSignpostsItems[0].landingSignpostModalId,
        modalText: landingSignpostsItems[0].landingSignpostModalText,
        modalImage: landingSignpostsItems[0].landingSignpostModalImage,
      })
    }
  }, [landingSignpostsItems])

  function clickHandler(item) {
    window.location.hash = "#" + item.landingSignpostModalId
    setActiveSignpost({
      modalHash: item.landingSignpostModalId,
      modalText: item.landingSignpostModalText,
      modalImage: item.landingSignpostModalImage,
    })
  }

  return (
    <>
      <section className="landing-signposts section-spacing-lg">
        <div className="content-block">
          {landingSignpostsTitle && (
            <h3
              className="landing-signposts__title lp-heading-lg"
              dangerouslySetInnerHTML={{ __html: landingSignpostsTitle }}
            />
          )}

          {landingSignpostsItems && Boolean(landingSignpostsItems.length > 0) && (
            <div className="lp-grid">
              {landingSignpostsItems.map(item => {
                const img = item.landingSignpostImage
                const modalImg = item.landingSignpostModalImage
                return (
                  <div
                    className="landing-signposts__item"
                    id={item.landingSignpostModalId}
                    key={item.landingSignpostModalId}
                  >
                    {getMediaUrl(img) && (
                      <img
                        className="landing-signpost-featured__image"
                        src={getMediaUrl(img)}
                        alt={img.altText || ""}
                        title={img.title || ""}
                      />
                    )}

                    <div className="landing-signposts-item__wrapper">
                      {item.landingSignpostTitle && (
                        <h3 className="landing-signpost__title lp-heading-sm">
                          {item.landingSignpostTitle}
                        </h3>
                      )}

                      {item.landingSignpostSubtitle && (
                        <h3 className="landing-signpost__subtitle lp-heading-sm">
                          {item.landingSignpostSubtitle}
                        </h3>
                      )}

                      {item.landingSignpostText && (
                        <div
                          className="landing-signpost__text lp-body-lg"
                          dangerouslySetInnerHTML={{
                            __html: item.landingSignpostText,
                          }}
                        />
                      )}

                      {item.landingSignpostButton?.title && (
                        <span className="landing-signpost-button__wrapper">
                          <button
                            className="landing-signpost__button lp-body-lg"
                            id={item.landingSignpostModalId}
                            popovertarget="landing-signpost-modal"
                            popovertargetaction="show"
                            onClick={() => clickHandler(item)}
                          >
                            {item.landingSignpostButton.title}
                          </button>
                        </span>
                      )}

                      {getMediaUrl(modalImg) && (
                        <img
                          className="landing-signpost-modal__image visually-hidden"
                          src={getMediaUrl(modalImg)}
                          alt={modalImg.altText || ""}
                          title={modalImg.title || ""}
                        />
                      )}

                      {item.landingSignpostModalText && (
                        <div className="landing-signpost-modal__text visually-hidden">
                          {item.landingSignpostModalText}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        <div
          className="signpost-modal dark"
          popover="auto"
          id="landing-signpost-modal"
          ref={popoverRef}
        >
          <div className="signpost-modal__content">
            <button
              className="signpost-modal__close"
              aria-label="Close modal"
              popovertarget="landing-signpost-modal"
              popovertargetaction="hide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
              >
                <g clipPath="url(#clip0_1_8)">
                  <path
                    d="M22.5 44C34.374 44 44 34.375 44 22.5C44 10.626 34.374 1 22.5 1C10.626 1 1 10.626 1 22.5C1 34.375 10.626 44 22.5 44Z"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <path
                    d="M14.2583 14.4686L30.7423 30.9526"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <path
                    d="M30.7416 14.4686L14.2576 30.9526"
                    stroke="white"
                    strokeWidth="2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_8">
                    <rect width="45" height="45" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <div className="signpost-modal__body">
              {getMediaUrl(activeSignpost.modalImage) && (
                <div className="signpost-modal-image__wrapper">
                  <img
                    className="signpost-modal__image"
                    src={getMediaUrl(activeSignpost.modalImage)}
                    alt={activeSignpost.modalImage.altText || ""}
                  />
                </div>
              )}
              {activeSignpost.modalText && (
                <div
                  className="signpost-modal__text"
                  dangerouslySetInnerHTML={{ __html: activeSignpost.modalText }}
                ></div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default LandingSignposts
